import React from 'react';
import { QueryHookOptions } from '@apollo/client';
import {
  FragmentData,
  OperationData,
  OperationVariables,
  gql,
} from '@ts-gql/tag';
import { useQuery } from '@ts-gql/apollo';

export const fragment = gql`
  fragment GetJobSignOffs_Fragment on Job {
    cloudId
    name
    clientId
    signOffRequestedByUserId
    signOffRequestedDateUtc
    signOffActionedDateUtc
    signOffStatus
  }
` as import('../../__generated__/ts-gql/GetJobSignOffs_Fragment').type;

export const GET_JOB_SIGN_OFFS_LIST_QUERY = gql`
  query getJobSignOffs($parameters: JobSignOffListInput!) {
    getJobSignOffs(parameters: $parameters) {
      data {
        ...GetJobSignOffs_Fragment
      }
    }
  }
` as import('../../__generated__/ts-gql/getJobSignOffs').type;

export type getJobSignOffsQueryVariables = OperationVariables<
  typeof GET_JOB_SIGN_OFFS_LIST_QUERY
>;
export type getJobSignOffsQueryResult = OperationData<
  typeof GET_JOB_SIGN_OFFS_LIST_QUERY
>;

export type GetJobSignOffListJobResult = FragmentData<typeof fragment> & {
  signOffRequestedDateUtc: Date | null;
  signOffActionedDateUtc: Date | null;
};
export type GetJobSignOffListResult = NonNullable<
  ReturnType<typeof processData>
>;

export const useGetJobSignOffsList = (
  options: QueryHookOptions<
    getJobSignOffsQueryResult,
    getJobSignOffsQueryVariables
  >
) => {
  const variables = options.variables as getJobSignOffsQueryVariables;

  const res = useQuery(GET_JOB_SIGN_OFFS_LIST_QUERY, {
    context: { service: 'core' },
    variables,
    ...options,
  });

  return React.useMemo(() => ({ ...res, data: processData(res.data) }), [res]);
};

export function processData(data: getJobSignOffsQueryResult | undefined) {
  const raw = data?.getJobSignOffs;
  const result = raw && {
    ...raw,
    data:
      raw.data?.map((job) => ({
        ...job,
        signOffRequestedDateUtc:
          job.signOffRequestedDateUtc && new Date(job.signOffRequestedDateUtc),
        signOffActionedDateUtc:
          job.signOffActionedDateUtc && new Date(job.signOffActionedDateUtc),
      })) || [],
  };

  return result;
}
